import React from 'react';
import TitleText from './TitleText';
import { Box } from '@material-ui/core';
import flight from '../../assets/images/pngwin.png';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
const FlightDealCityCard = () => {
	const { city } = useParams();
	const history = useHistory();
	return (
		<>
			<Box
				onClick={() => history.push(`/flightdeal/${city}/${city}`)}
				display='flex'
				style={{
					boxShadow: '0 4px 8px 0 rgb(0 0 0 / 20%)',
					borderRadius: 12,
					cursor: 'pointer',
					backgroundImage: `url(${flight})`,
					backgroundRepeat: 'no-repeat',
					backgroundPosition: '-458px -92px',
					position: 'relative',
					height: 135,
					justifyContent: 'center',
					alignItems: 'center',
				}}>
				<TitleText textStyle={{ fontSize: 26, color: 'navy' }}>
					{city}
				</TitleText>
				<TitleText textStyle={{ fontSize: 26, color: 'navy' }}>-</TitleText>
				<TitleText textStyle={{ fontSize: 26, color: 'navy' }}>
					Kolkata
				</TitleText>
			</Box>
		</>
	);
};

export default FlightDealCityCard;
